
import { useEffect } from 'react';

export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Satisfy&display=swap';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/3f0c57e83fd614b626230dadf17ae7f4.jpeg"
          alt="Zane Morehouse pitching"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-red-950/35 via-transparent to-transparent"></div>
      </div>

      {/* Animated Fog Effect */}
      <div className="absolute bottom-0 left-0 right-0 h-64 bg-gradient-to-t from-black/60 to-transparent"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-6xl mx-auto w-full flex flex-col items-center justify-center h-full">
        {/* Main Headline */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white uppercase tracking-wider mb-4 md:mb-6 leading-tight flex flex-col items-center">
          <span className="mb-[-80px] md:mb-[-150px] lg:mb-[-270px] z-10 relative text-3xl md:text-5xl lg:text-6xl">ZANE</span>
          <div className="w-full max-w-xs md:max-w-2xl lg:max-w-3xl overflow-hidden">
            <img
              src="https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/83a694954fd8ff4db81a4fc3c6d7eeaa.png"
              alt="Nightmare"
              className="w-full h-auto object-contain"
              style={{
                filter: 'brightness(0) saturate(100%) invert(12%) sepia(100%) saturate(5000%) hue-rotate(360deg) brightness(85%) contrast(110%) drop-shadow(0 0 15px rgba(220, 60, 60, 0.6)) drop-shadow(0 0 35px rgba(220, 60, 60, 0.4)) drop-shadow(0 0 60px rgba(220, 60, 60, 0.2))'
              }}
            />
          </div>
          <span className="mt-[-100px] md:mt-[-200px] lg:mt-[-320px] z-10 relative text-3xl md:text-5xl lg:text-6xl">MOREHOUSE</span>
        </h1>

        {/* Subtitle */}
        <p className="text-base md:text-xl lg:text-2xl text-gray-400 font-light tracking-widest uppercase mt-4 md:mt-6">
          Professional Baseball Player
        </p>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex flex-col items-center animate-bounce">
        <i className="ri-arrow-down-line text-gray-600 text-3xl"></i>
        <span className="text-gray-600 text-xs tracking-widest uppercase mt-2">Scroll to Explore</span>
      </div>
    </section>
  );
}
